import { useQuery } from '@tanstack/react-query';

import { publisherTypeOptions } from '@/module/Nomen/PublisherType/model/PublisherTypeModel';

import { FilterInputProps, SelectFilter, useFilterOptions } from '@/core/components';

type PublisherTypeFilterProps = FilterInputProps;

export function PublisherTypeFilter(props: PublisherTypeFilterProps) {
  const { data, isLoading, isError } = useQuery(publisherTypeOptions.getAll());
  const options = useFilterOptions(data);
  return (
    <SelectFilter
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
